import React from "react";
import "./Results.css";

const Results = () => {
  return (
    <main className="results-page">

      <section className="results-hero">

        <p>OUR RESULTS</p>

        <h1>
          Results That
          <span> Speak For Themselves</span>
        </h1>

        <p>
          Explore how our digital marketing strategies have helped
          businesses improve performance, generate leads, and grow.
        </p>

      </section>


      <section className="results-content">

        <div className="result-card">
          <h2>Google Ads</h2>
          <p>
            Campaigns optimized for qualified traffic and conversions.
          </p>
        </div>

        <div className="result-card">
          <h2>Lead Generation</h2>
          <p>
            Targeted campaigns designed to generate high-quality leads.
          </p>
        </div>

        <div className="result-card">
          <h2>Business Growth</h2>
          <p>
            Data-driven strategies focused on measurable business growth.
          </p>
        </div>

      </section>

    </main>
  );
};

export default Results;